// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281704/js/" + chunkId + "." + {"44":"69a5ac5a","225":"94dff467","481":"7a523536","486":"38077c72","770":"b76b8c0e"}[chunkId] + ".0.25742103753657253.chunk.js";
};